<template>
    <div class="error-resolution">
        <div class="row-flex">
            <h5>Import Errors ({{ importErrors.length }})</h5>
            <div>
                <span v-if="resolvedErrorCount > 0" class="success-text"><CheckIcon />{{ resolvedErrorCount }} Error Resolved</span>
                <el-button
                    style="border: 0; min-width: 140px;"
                    :loading="ignoringErrorIds.length > 0"
                    @click="resolveErrors"
                    v-bind:disabled="Object.keys(response).length > 0 ? false : true"
                >
                    {{ ignoringErrorIds.length == 0 ? "Resolve Errors" : "" }}
                </el-button>
            </div>
        </div>
        <div class="error-section" v-bind:key="index" v-for="(obj, index) in timedImportErrors">
            <div class="row-header row-header--time">
                <p>{{ obj.dateString }}</p>
            </div>
            <div>
                <table class="table resolution-table">
                    <template v-for="(error, i) in obj.list">
                        <thead v-bind:key="'thead1'+i">
                            <tr class="row-header row-header--type">
                                <th colspan="5" class="title">{{ error.displayName }} ({{error.list.length}})</th>
                                <th colspan="3" />
                                <th colspan="2" style="text-align: right;">
                                    <a @click="ignoreAll(error.list)" v-bind:class="ignoringErrorIds.length > 0 ? 'disabled' : ''" href="javascript:void(0)" class="cta">Ignore
                                        all</a>
                                </th>
                            </tr>
                        </thead>
                        <thead v-bind:key="'thead2'+i" v-if="i < 1">
                            <tr>
                                <th></th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Provider</th>
                                <th>Patient</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Appointment</th>
                                <th>Comments</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="'body'+i">
                            <template v-for="(row, j) in error.list">
                                <template v-if="!ignoringErrorIds.includes(row.data.id)">
                                    <ResolveRow
                                        @make-resolve-response="makeResolveResponse"
                                        :key="j"
                                        :index="j"
                                        :row="row"
                                        :mapped-events="mappedEvents"
                                        :response="response" ></ResolveRow>
                                    <tr v-bind:key="'error-row'+j" v-if="row.error">
                                        <td colspan="10" style="color: #da4e4e; font-size: 12px; font-weight: 600;">
                                            {{ row.error ? row.error.replace('time', 'date or time') : '' }}
                                        </td>
                                    </tr>
                                    <tr v-if="row.data && row.data.raw && (row.data.raw.row || row.data.transform)" class="raw-data-row" v-bind:key="'rawData'+j">
                                        <td colspan="10" style="padding: 0px 0 20px 0;">
                                            <RawDataRow v-bind:raw="getRowData(row.data)"/>
                                        </td>
                                    </tr>
                                </template>
                                <tr v-else v-bind:key="'loader'+j">
                                    <td colspan="10">
                                        <div style="height: 90px;" v-loading="true"></div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </template>
                </table>
            </div>
        </div>
    </div>

</template>
<script>
    import {
        mapActions,
        mapState
    } from "vuex"
    import ResolveRow from './ResolveRow'

    import CheckIcon from "./../icons/CheckIcon"
    import RawDataRow from "./RawData"
    import getTimeformat from "./../util/getTimeformat"
    export default {
        name: 'error-resolution-table',
        components: {
            ResolveRow,
            CheckIcon,
            RawDataRow
        },
        data() {
            return {
                response: {}
            }
        },
        methods: {
            ...mapActions('provider', [
                'ignoreImportError',
                'resolveImportErrors'
            ]),
            getTimeformat: getTimeformat,
            getChangedValues(id) {
                if(this.response[id]) {
                    return this.response[id]["data"]["solution"]
                }
                return {}
            },
            makeResolveResponse(key, value, row) {
                const id = row.data.id
                if (!this.response[id]) {
                    this.response[id] = {
                        key: {
                            provider: row.data.provider,
                            id: row.data.id
                        },
                        data: {
                            problem: row.errorType,
                            solution: {
                                "action": "new_schedule",
                                ...row.data.transform,
                                [key]: value
                            }
                        }
                    }
                    if(key === 'date' || key === 'hours') {
                        const setDate = this.response[id]["data"]["solution"]["date"],
                            setTime = this.response[id]["data"]["solution"]["hours"]
                        if(setDate && setTime) {
                            this.response[id]["data"]["solution"]["time"] = new Date(`${setDate} ${setTime}`).getTime()
                        }
                    }
                    this.$forceUpdate()
                    return this.response
                }
                if(key === 'date' || key === 'hours') {
                    const setDate = this.response[id]["data"]["solution"]["date"],
                        setTime = this.response[id]["data"]["solution"]["hours"]
                    if(setDate && setTime) {
                        this.response[id]["data"]["solution"]["time"] = new Date(`${setDate} ${setTime}`).getTime()
                    }
                }
                this.response[id]["data"]["solution"][key] = value
                this.$forceUpdate()
                return this.response
            },
            resolveErrors() {
                const keyList = Object.keys(this.response)
                const validResolves = []
                const requiredKeys = ["provider", "event", "date", "name", "email"]
                for(let i = 0 ; i < keyList.length ; i++) {
                    const res = this.response[keyList[i]]
                    // if(requiredKeys.every(k => {
                    //     if(res.data.solution[k] instanceof Object && Object.keys(res.data.solution[k]) <= 0) {
                    //         return false
                    //     }
                    //     if(!res.data.solution[k]) {
                    //         return false
                    //     }
                    //     return true
                    // })) {
                        validResolves.push(res)
                        delete this.response[keyList[i]]
                    // }
                }
                if(validResolves.length > 0) {
                    this.resolveImportErrors({
                        record: validResolves,
                        type: 'resolution'
                    })
                }
            },
            changeDate(ev, row) {
                this.makeResolveResponse(ev.name, ev.event, row)
            },
            changeTime(ev, row) {
                this.makeResolveResponse(ev.name, ev.event, row)
            },
            changeText(ev, row) {
                this.makeResolveResponse(ev.name, ev.event, row)
            },
            onOptionSelect(ev, row) {
                if (ev.type === "invalid_provider" && ev.name === "provider") {
                    const providerId = ev.item.provider
                    row.data.transform = {
                        ...row.data.transform,
                        event: row.transform.event || "",
                        doctorName: ev.item.name,
                        provider: providerId
                    }
                    this.makeResolveResponse("event", "", row)
                    this.makeResolveResponse("provider", providerId, row)
                    return this.makeResolveResponse("doctorName", ev.item.name, row)
                }
                if(ev.name === "event") {
                    row.data.transform = {
                        ...row.data.transform,
                        doctorName: ev.item.doctorName,
                        provider: ev.item.provider
                    }
                }
                return this.makeResolveResponse(ev.name, ev.item.id, row)
            },
            ignoreAll(list) {
                const res = {
                    "record": list.map((item) => {
                        return {
                            key: {
                                provider: item.data.provider,
                                id: item.data.id
                            },
                            data: {
                                ignore_record: true
                            }
                        }
                    }),
                    type: "patch_record"
                }
                this.ignoreImportError(res)
            },
            getRowData(data) {
                if(data.transform.source === "spreadsheet")
                    return data.raw.row
                let transform = data.transform
                let timeEvent = transform.date == "" ? "" : this.getTimeformat(new Date(transform.date), true, false)
                return [
                    transform.name,
                    transform.email,
                    timeEvent,
                    transform.phone,
                    transform.notes,
                    transform.type
                ]
            }
        },
        computed: {
            ...mapState('provider', [
                'importErrors',
                'importMapping',
                'providers',
                'provider',
                'ignoringErrorIds',
                'resolvedErrorCount',
                'profile'
            ]),
            ...mapState('content', [
                'data'
            ]),
            mappedEvents() {
                return this.providers.map((p) => {
                    if(p.profile) {
                        const events = p.profile.reduce((a, ev) => {
                            if(ev.event) {
                                a = [...a, ...ev.event]
                            }
                            return a
                        }, [])
                        const options = events.reduce((acc, val) => {
                            const eventObj = this.data.event[val]
                            if(eventObj && !eventObj.archived && eventObj.name)
                                acc.push(eventObj)
                            return acc
                        }, []).sort((ev1, ev2) => {
                            return ev1.name.localeCompare(ev2.name)
                        }).map(o => {
                            return {
                                ...o,
                                doctorName: p.name
                            }
                        })
                        return {
                            provider: p.provider,
                            label: p.name,
                            options
                        }
                    }
                })
            },
            timedImportErrors() {
                const errorTypeOrder = [
                    ["multiple_matches", "same_schedule"],
                    "invalid_provider",
                    "date",
                    "no_match",
                    "name",
                    "email",
                    "phone"
                ]
                const typeNameMap = {
                    same_schedule: "Multiple Appointments",
                    multiple_matches: "Multiple Appointments",
                    invalid_provider: "Missing Doctor",
                    date: "Missing Date and Time",
                    no_match: "Missing Appointment",
                    name: "Missing Name",
                    email: "Missing Email",
                    phone: "Missing Phone"
                }
                return Object.values([...this.importErrors].reduce((acc, errObject) => {
                    const err = errObject.data
                    const timestamp = err.audit ? err.audit.split(":")[0] : String(err.created)
                    if (!acc[timestamp]) {
                        acc[timestamp] = {
                            upload_timestamp: timestamp,
                            dateString: getTimeformat(parseInt(timestamp, 10)),
                            list: [
                                errObject
                            ]
                        }
                        return acc
                    }
                    acc[timestamp].list.push(errObject)
                    return acc
                }, {})).sort((a, b) => b.upload_timestamp - a.upload_timestamp).map((obj, index) => {
                    return {
                        ...obj,
                        list: obj.list.reduce((acc, err) => {
                            const problemTypes = err.data.problem.reduce((acc, problem) => {
                                if (problem.key.length > 0 && problem.status === "pending") {
                                    [...problem.key].forEach(type => {
                                        const str = type.split(":")
                                        acc[0].push(str[0])
                                        acc[1].push(str[1] || "")
                                    })
                                }
                                return acc
                            }, [
                                [], // for prefix,
                                [] // for suffix
                            ])
                            for (let i = 0; i < errorTypeOrder.length; i++) {
                                let typeOrder = errorTypeOrder[i]
                                const isTypeArray = typeOrder instanceof Array
                                if (
                                    isTypeArray ?
                                    typeOrder.some((t) => problemTypes[0].includes(t)) :
                                    problemTypes[0].includes(typeOrder)
                                ) {
                                    let errorType = ""
                                    if (isTypeArray) {
                                        errorType = typeOrder.find(val => problemTypes[0].find((v) =>
                                            v === val))
                                        typeOrder = errorType
                                    } else {
                                        const atIndex = problemTypes[0].indexOf(typeOrder)
                                        errorType =
                                            `${typeOrder}${problemTypes[1][atIndex] ? `:${problemTypes[1][atIndex]}` : ""}`
                                    }
                                    if (acc[i]) {
                                        acc[i].list.push({
                                            ...err,
                                            errorType,
                                            type: typeOrder
                                        })
                                    } else {
                                        acc[i] = {
                                            displayName: typeNameMap[typeOrder],
                                            type: errorType,
                                            list: [{
                                                ...err,
                                                errorType,
                                                type: typeOrder
                                            }]
                                        }
                                    }
                                }
                            }
                            return acc
                        }, []).filter(o => o !== null)
                    }
                }).filter(el => el.list.length > 0)
            }
        }
    }
</script>

<style scoped lang="scss">
@import "style.scss";
</style>